import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconCollapseChevronOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24"><g fill="currentColor"><path d="M12 10.287.22 1.008C-.073.776-.073.403.22.173a.9.9 0 0 1 1.06 0L12 8.616 22.723.173a.9.9 0 0 1 1.06 0c.293.233.293.606 0 .836zM12 13.714l11.782 9.277c.293.233.293.607 0 .837a.9.9 0 0 1-1.06 0L12 15.384 1.28 23.828a.9.9 0 0 1-1.061 0c-.293-.234-.293-.607 0-.837z" /></g></svg>
);
